export default __webpack_public_path__ + "static/media/Step-1.f6194c43.webm";